import moment from "moment";
import getAppErrors from "./appErrors";

const getCompletedStatus = ({
  restaurantStatusCode,
  restaurantStatusParams
}) => {
  let closedStatus = null,
    completedStatus = null;
  if (restaurantStatusCode) {
    closedStatus = getAppErrors(restaurantStatusCode);
    let formattingDate = "";
    const paramTime = restaurantStatusParams[0];
    if (paramTime) {
      if (paramTime.includes(" ")) {
        const openingDate = moment.utc(paramTime, "DD-MM-YYYY HH");
        formattingDate = openingDate.local().format("DD-MM-YYYY HH");
      } else {
        if (paramTime.length > 5) {
          const openingDate = moment.utc(paramTime, "DD-MM-YYYY");
          formattingDate = openingDate.local().format("DD-MM-YYYY");
        } else {
          const openingDate = moment.utc(paramTime, "HH");
          formattingDate = openingDate.local().format("HH:mm");
        }
      }
    }

    completedStatus =
      (closedStatus &&
        closedStatus.message.indexOf("[:par1]") !== -1 &&
        closedStatus.message.replace("[:par1]", `${formattingDate}`)) ||
      closedStatus.message;
  }
  return completedStatus;
};

export default getCompletedStatus;
